/* global I18n */
import React, { useContext, useEffect, useRef } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import {
  bundleProductsI18Options,
  BUNDLES_PANEL,
  filesI18nOptions,
  PREVIEW, PRODUCT,
} from '../../components/products/constants'
import { UploadContext } from '../../contexts/UploadContext'
import { FileContext } from '../../contexts/FileContext'
import { ProductContext } from '../../contexts/ProductContext'
import UploadsProgress from '../../components/publisher/ProductFiles/UploadsProgress'
import {
  previewErrors, titlesWithErrors,
} from '../../utils/ProductFiles'
import { useFormContext } from 'react-hook-form'
import { UIContext } from '../../contexts/UIContext'
import { NotificationContext } from '../../contexts/NotificationContext'
import BundlesPreviewFiles from './BundlesPreviewFiles'
import BundlesProductSelector from './BundlesProductSelector'
import { BundlesContext } from './BundlesProvider'

const bundlesI18nOptions = {
  scope: 'turbosquid.products.bundles',
}
const myProductsI18nOptions = {
  scope: 'turbosquid_products.messages',
}

export default function BundlesPanel() {
  const { files } = useContext(FileContext)
  const { uploads } = useContext(UploadContext)
  const { setIsBundleProduct } = useContext(ProductContext)
  const { currentTab, setCurrentTab } = useContext(UIContext)
  const { clearNotifications, notifications } = useContext(NotificationContext)
  const { formState: { errors: formErrors } } = useFormContext()
  const isIntentionalNavigationRef = useRef(false)

  const { metadataForm, searchSelect, dirty } = useContext(BundlesContext)

  const {
    bundlePrice,
    setBundlePrice,
    bundlePriceValidation,
    setBundlePriceValidation,
  } = metadataForm

  const { totalPrice, selectedSearchResults } = searchSelect

  const selectedProducts = { ...selectedSearchResults }

  useEffect(() => {
    if (totalPrice) {
      if (Number(bundlePrice) < 1 && Number(totalPrice) > 0) {
        setBundlePriceValidation({ type: 'minLength' })
        return
      }

      if (Number(bundlePrice) < 1 && Number(totalPrice) < 1) {
        setBundlePriceValidation(null)
        return
      }

      if (Number(bundlePrice) !== 0 && Number(bundlePrice) < Number(totalPrice)) {
        setBundlePriceValidation(null)
      }

      if (Number(bundlePrice) > Number(totalPrice) && selectedProducts) {
        setBundlePriceValidation({ type: 'maxLengthBundle' })
      }

      if (Number(bundlePrice) < Number(totalPrice)) {
        setBundlePriceValidation(null)
      }
    }
  }, [totalPrice, bundlePrice])

  useEffect(() => {
    setIsBundleProduct(true)
  }, [])

  useEffect(() => {
    const handleAllowNavigation = () => {
      isIntentionalNavigationRef.current = true
    }
    const handleResetNavigation = () => {
      isIntentionalNavigationRef.current = false
    }

    window.addEventListener('bundle:allow-navigation', handleAllowNavigation)
    window.addEventListener('bundle:reset-navigation', handleResetNavigation)
    return () => {
      window.removeEventListener('bundle:allow-navigation', handleAllowNavigation)
      window.removeEventListener('bundle:reset-navigation', handleResetNavigation)
    }
  }, [])

  useEffect(() => {
    const handleNavigate = (e) => {
      if (isIntentionalNavigationRef.current) return
      if (!dirty.isDirty) return
      if (e.defaultPrevented) return

      const anchor = e.target.closest?.('a')
      if (!anchor) return
      if (e.button !== 0) return
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      if (anchor.target && anchor.target !== '_self') return

      const pathName = anchor.pathname || ''
      const isCurrentBundleRoute = anchor.origin === window.location.origin
        && pathName === window.location.pathname
        && (anchor.search || '') === window.location.search

      if (!isCurrentBundleRoute) {
        const leave = window.confirm(I18n.t('pending_updates', myProductsI18nOptions))
        if (!leave) {
          e.preventDefault()
        } else {
          e.preventDefault()
          window.dispatchEvent(new CustomEvent('bundle:allow-navigation'))
          try {
            window.location.href = anchor.href
          } catch (_error) {
            window.dispatchEvent(new CustomEvent('bundle:reset-navigation'))
          }
        }
      }
    }
    document.addEventListener('click', handleNavigate)
    return () => document.removeEventListener('click', handleNavigate)
  }, [dirty.isDirty])

  useEffect(() => {
    const handleBrowserNavigate = (e) => {
      if (isIntentionalNavigationRef.current) return
      if (!dirty.isDirty) return
      e.preventDefault()
      e.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBrowserNavigate)
    return () => window.removeEventListener('beforeunload', handleBrowserNavigate)
  }, [dirty.isDirty])

  const errors = {
    [PRODUCT]: [],
    [PREVIEW]: previewErrors(formErrors),
  }

  const titles = {
    [PRODUCT]: I18n.t('bundle_products', bundleProductsI18Options),
    [PREVIEW]: I18n.t('bundle_images', filesI18nOptions),
  }

  const tabs = titlesWithErrors(files, uploads, titles, errors)

  // Set starting tab
  useEffect(() => {
    setCurrentTab(PRODUCT)
  }, [])

  // Clear notifications when changing tabs
  useEffect(() => {
    if (notifications.length) {
      clearNotifications()
    }
  }, [currentTab])

  return (
    <div className="panel panel-default files-panel files-panel-container">
      <Tabs
        id={BUNDLES_PANEL}
        activeKey={currentTab}
        onSelect={setCurrentTab}
      >
        <Tab eventKey={PRODUCT} title={tabs[PRODUCT]} className={false ? 'with-alert' : ''}>
          <BundlesProductSelector />
        </Tab>
        <Tab eventKey={PREVIEW} title={tabs[PREVIEW]} className={false ? 'with-alert' : ''}>
          <BundlesPreviewFiles />
        </Tab>
      </Tabs>
      {/* <UndoDeleteNotification /> */}
      <UploadsProgress />
    </div>
  )
}
